import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container, Button, Box, Grid, Typography, Pagination } from "@mui/material";
import {
  COMPANY,
  COMPANYALL,
  PACKAGE
} from "../../services/actions";

import Form from "./Form";
import ActionBar from "../extra/ActionBar";
import companyPng from './company.png'
import { isBase64Image } from "../../libs/Libs";
import SearchBar from "../extra/SearchBar";
import InfoCard2 from "../extra/InfoCard2";
import XTable from "../extra/XTableAnother";
import MoreInfo from "../extra/MoreInfo";

export default function View() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const PACKAGE = "PACKAGE";
  const [open, setOpen] = React.useState(false);
  const [defV, setDefV] = React.useState({});
  const [view, setView] = React.useState(1);
  const companyState = useSelector((state) => state?.companyState);
  const companyallState = useSelector((state) => state?.companyallState);
  const packageState = useSelector((state) => state?.packageState);
  const user = useSelector((state) => state?.loginState?.auth);

  const [page, setPage] = React.useState(0); // current page  
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchCompanies = (page = 0) => {
    const url = page === 0 ? `company/${page}/` : `company/?page=${page}`;// pass page number    
    dispatch({ type: `${COMPANYALL}_GET`, payload: url });
  }


  React.useEffect(() => {
    fetchCompanies(0);
  }, []);

  React.useEffect(() => {
    fetchCompanies(page);
  }, [page]);


  // Reload companies when one is added or edited
  React.useEffect(() => {
    if (companyState.success) {
      setOpen(false);
      dispatch({ type: `${COMPANYALL}_GET`, payload: 0 });
    }
  }, [companyState?.data]);

  // Toggle form open with optional default values
  const handleFormOpen = (defaults = {}) => {
    console.log("FOR EDIT", defaults)
    setDefV(defaults);
    dispatch({ type: `${PACKAGE}_GET`, payload: 0 });
    setOpen(true);
  };


  // Submit new company
  const handleFormSubmit = (data) => {
    let filteredData = {}
    const keys = ["company_name", "company_email", "package",
      "company_phone", "address", "country_code", "country", "country_name",
      "website", "image", "country_code", "fax", "city", "keyperson",
      "keypersonphone"
    ]
    keys.map((key, i) => {
      if (data[key]) {
        filteredData[key] = data[key]
      }
      if (!isBase64Image(data.image)) {
        delete data["image"]
      }
    })
    const payload = data?.id ? {
      id: data.id,
      main_role: "Company",
      ...filteredData,
      user: {
        username: data.username,
        password: data.password,
        first_name: data.first_name,
        last_name: data.last_name,
        country_code: data.user_country_code,
        phone: data.phone,

      },
    } : {
      id: data.id,
      ...filteredData,
      user: {
        username: data.username,
        password: data.password,
        first_name: data.first_name,
        last_name: data.last_name,
        country_code: data.user_country_code,

        phone: data.phone,

      },
    };
    let action = data?.id ? `${COMPANY}_PATCH` : `${COMPANY}_POST`
    dispatch({ type: action, payload });
  };

  // Handle company delete
  const handleDelete = (id) => {
    dispatch({ type: `${COMPANY}_DELETE`, payload: id });
  };

  // Handle filter search
  const handleSearch = (key, value) => {
    const query = `company/0/?filter_by={"${key}__istartswith":"${value}"}`;
    dispatch({ type: `${COMPANYALL}_GET`, payload: query });
  };

  const tableHeadings = ['id', 'image', 'Company Name', 'Phone', 'Email', 'Project Count', 'Camera Count', 'User Count'];
  const tableRows = companyallState?.data?.results?.map((company) => ({
    id: company.id,
    image: company.image,
    company_name: company.company_name,
    company_phone: company.company_phone,
    company_email: company.company_email,
    project_count: company.project_count,
    camera_count: company.camera_count,
    user_count: company.user_count,
  }));

  return (
    <>
      {open ? (
        <Box sx={{ p: 2 }}>
          <Form
            packages={packageState?.data?.results}
            defaultValues={defV}
            onCancel={() => setOpen(false)}
            onSubmit={handleFormSubmit}
          />
        </Box>
      ) : (
        <Container maxWidth="false" className="py-3">
          <ActionBar
            hasPermission={user?.permissions?.includes("company.add_company")}
            label="Company"
            btnLabel="ADD COMAPNY"
            setOpen={() => handleFormOpen()}
            onBtnClick={(type, col) => {
              if (type === "grid") {
                setView(1);
              }
              if (type === "tabular") {
                setView(2);
              }
            }}
            showGrid={[2, 5]}
          />

          <SearchBar bylist={["company_name"]} handleSearch={handleSearch} />

          {view === 1 && (
            <>

              <Grid container spacing={2} alignItems="stretch">
                {companyallState?.data?.results?.map((company, index) => {
                  if (!company?.image) {
                    company.image = companyPng
                  }
                  const data = {
                    ...company,
                    no_users: company?.users?.length,
                  };

                  return (

                    <Grid size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }} key={company.id || index}>
                      <InfoCard2
                        img_type={"company"}
                        keys={[
                          "image",
                          "company_name",
                          "company_phone",
                          "company_email",
                          "Projects",
                          "project_count",
                          "Camera",
                          "camera_count",
                          "User",
                          "user_count",

                        ]}
                        data={data}
                        onClick={() => {
                          // navigate if needed
                        }}
                        onAction={(action) => {
                          if (action === "Edit") {
                            let redata = {
                              ...data,
                              first_name: data.user.first_name,
                              last_name: data.user.last_name,
                              phone: data.user.phone,
                              user_country_code: data.user.country_code,
                            }
                            handleFormOpen(redata);
                          } else if (action === "Delete") {
                            handleDelete(data.id);
                          }
                          else if (action == "More") {
                            setDefV(data);
                            setView(4)
                          }
                        }}
                      />
                    </Grid>
                  );
                })}
              </Grid>

              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Pagination
                  count={Math.ceil(companyallState?.data?.count / pageSize)}
                  page={page}
                  onChange={(e, value) => setPage(value)}
                  color="primary"
                />
              </Box>
            </>
          )}

          {view === 2 && (
            <XTable
              head={tableHeadings}
              rows={tableRows}

              onEdit={(row) => {
                // Find the full company data from the original state using the company name or ID
                const fullCompanyData = companyallState?.data?.results?.find(
                  (company) => company.company_name === row.company_name
                );

                // Add a safety check in case the data is not found
                if (!fullCompanyData) {
                  console.error("Could not find full company data for editing.");
                  return;
                }

                // Perform the data transformation on the full data object
                const redata = {
                  ...fullCompanyData,
                  first_name: fullCompanyData.user.first_name,
                  last_name: fullCompanyData.user.last_name,
                  phone: fullCompanyData.user.phone,
                  user_country_code: fullCompanyData.user.country_code,
                };

                handleFormOpen(redata);
              }}
              onDelete={handleDelete}
            // You can pass action handlers here if you want to make the table interactive
            />
          )}
          {view === 4 && <MoreInfo
            data={{ ...defV }}
            // skip={[ 'company', 'description']}
            group={['', '', 'company_name', 'created_at',]}
            // icons={{ access_location: <BsCopy /> }}
            // css={{ access_location: { color: '#1976d2' } }}
            onClose={() => { setView(1) }} />}
        </Container>
      )}
    </>
  );
}